<template>
  <div class="content">
    <div class="btn-container u-pull-right u-text-right">
      <router-link
        v-if="exam.candidate"
        :to="{ name: 'record-file', params: { id: exam.candidate.id } }"
        class="action-button"
      >
        <button class="btn-dark">
          <i
            class="fa-wrapper fa fa-folder-open normal-icon pad-right"
            aria-hidden="true"
          ></i>
          File
        </button>
      </router-link>
      <back-button></back-button>
    </div>
    <div v-if="loading.kdr">
      <placeholder title="Loading KDR"></placeholder>
    </div>
    <div v-else>
      <h2 class="font-light">Knowledge Deficiency Report</h2>
      <h4 class="font-light">{{ exam.title }}</h4>
      <exam-info v-bind:exam="exam"></exam-info>
      <server-error v-bind:error="error.serverError"></server-error>
      <space v-if="error.serverError"></space>
      <div class="section u-text-right">
        <exam-download-kdr v-bind:exam="exam" label="PDF"></exam-download-kdr>
      </div>
      <!-- KDR -->
      <div class="frame">
        <div class="frame-header">
          <div class="frame__title u-text-center">
            Knowledge Deficiency Report
          </div>
        </div>
        <div class="frame__body">
          <p>
            This <i>Knowledge Deficiency Report (KDR)</i> was generated from the
            exam completed by {{ exam.candidate.full_name }} on
            {{ formatDate(exam.date) }}. For each topic included in the exam,
            this <i>KDR</i> lists the syllabus references for all questions that
            weren't answered correctly.
          </p>
        </div>
      </div>
      <div class="divider"></div>
      <div v-if="kdr.length == 0">
        <h4 class="font-light">No Knowledge Deficiencies</h4>
        <p>
          All questions in this exam were answered correctly and there are no
          areas of knowledge which did not meet the required standard during the
          examination.
        </p>
      </div>
      <div v-for="(section, idx) in kdr" v-bind:key="`kdr-${idx}`">
        <h4 class="font-light">{{ section.topic }}</h4>
        <ul
          v-for="(entry, idx) in section.entries"
          v-bind:key="`entry-${idx}`"
          class="fa-ul"
        >
          <li>
            <span class="fa-li">
              <i class="fas fa-angle-double-right"></i>
            </span>
            {{ entry }}
          </li>
        </ul>
      </div>
      <div class="divider"></div>
      <h6 class="font-light u-fill-width u-text-center">
        *** END OF REPORT ***
      </h6>
    </div>
  </div>
</template>
<style>
.frame__title {
  font-weight: 800;
  font-size: 1.2rem;
}
</style>
<script>
import { mapGetters } from "vuex";
import { DateFormatter } from "@/functions/dateFormat.function";
import ExamInfo from "@/components/exams/ExamInfo";
import ExamDownloadKdr from "@/components/exams/ExamDownloadKDR";
import BackButton from "@/components/BackButton";
import Placeholder from "@/components/Placeholder";
import ServerError from "@/components/ServerError";
import { scrollToTop } from "@/functions/scrollToTop";

export default {
  name: "exam-kdr",
  components: {
    ExamInfo,
    BackButton,
    Placeholder,
    ServerError,
    ExamDownloadKdr
  },
  computed: {
    ...mapGetters("core", ["error"]),
    ...mapGetters("exams", ["loading"]),
    kdr: function() {
      var result = this.$store.state.exams.kdrs[this.$route.params.id];
      if (!result) {
        return [];
      } else {
        return result;
      }
    },
    exam: function() {
      var result = this.$store.state.exams.exams[this.$route.params.id];
      if (!result) {
        return {};
      } else {
        return result;
      }
    }
  },
  methods: {
    formatDate: function(dateString) {
      var result = DateFormatter(dateString);
      return result;
    }
  },
  mounted() {
    // Clear any errors from other exams
    this.$store.commit("core/clearErrors");
    this.$store.dispatch("exams/getExam", { id: this.$route.params.id });
    this.$store.dispatch("exams/getExamKDR", { id: this.$route.params.id });
    scrollToTop();
  }
};
</script>
